import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBankIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.31579 25.7143V45.7143H15.7895V25.7143H6.31579ZM25.2632 25.7143V45.7143H34.7368V25.7143H25.2632ZM0 60H60V51.4286H0V60ZM44.2105 25.7143V45.7143H53.6842V25.7143H44.2105ZM30 0L0 14.2857V20H60V14.2857L30 0Z",
		fill: "#01A77B"
	})
});
export default SvgBankIcon;
